export default __webpack_public_path__ + "static/toolbar-view-actions-dark-mode-818d7be36a92283693b52de848fda8e3.png";